import { render, staticRenderFns } from "./UserCreateModal.vue?vue&type=template&id=5b487455&scoped=true"
import script from "./UserCreateModal.vue?vue&type=script&lang=js"
export * from "./UserCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b487455",
  null
  
)

export default component.exports